export const CMS_HOST = process.env.CMS_HOST
export const CMS_TOKEN = process.env.CMS_TOKEN
export const CORE_HOST = process.env.CORE_HOST
export const CORE_API_KEY = process.env.CORE_API_KEY
